module.exports={author:"manuel arturo abreu",date:"09/14/2019",publishDate:"09/14/2019",highlighted:!1,tags:"",title:"Ablation"};